"use client";

import { useEffect, useState } from "react";

export default function TrainersDisplay() {
  const [trainers, setTrainers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTrainers();
  }, []);

  const fetchTrainers = async () => {
    try {
      const res = await fetch("/api/trainers", { cache: "no-store" });
      if (!res.ok) throw new Error("Failed to load trainers");
      const data = await res.json();
      setTrainers(data.trainers || []);
    } catch (error) {
      console.error("Error fetching trainers:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="bg-white rounded-lg p-6 shadow-sm text-center border border-[#D4AF37]/30 animate-pulse"
          >
            <div className="w-20 h-20 bg-gray-200 rounded-full mx-auto mb-4"></div>
            <div className="h-4 bg-gray-200 rounded w-24 mx-auto mb-2"></div>
            <div className="h-3 bg-gray-200 rounded w-32 mx-auto mb-2"></div>
            <div className="h-3 bg-gray-200 rounded w-28 mx-auto"></div>
          </div>
        ))}
      </div>
    );
  }

  if (trainers.length === 0) {
    return (
      <p className="text-center text-gray-500 py-8">
        No trainers available at this time.
      </p>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {trainers.map((trainer) => (
        <div
          key={trainer.id}
          className="bg-white rounded-lg p-6 shadow-sm text-center border border-[#D4AF37]/30"
        >
          <div className="w-20 h-20 bg-[#FFF8E7] rounded-full mx-auto mb-4 flex items-center justify-center border-2 border-[#D4AF37] overflow-hidden">
            {trainer.imageUrl ? (
              <img
                src={trainer.imageUrl}
                alt={trainer.name}
                className="w-full h-full object-cover"
              />
            ) : (
              <span className="text-2xl">{trainer.emoji || "👤"}</span>
            )}
          </div>
          <h4 className="font-semibold text-gray-900 mb-1">{trainer.name}</h4>
          {trainer.title && (
            <p className="text-sm text-gray-600 mb-2">{trainer.title}</p>
          )}
          {trainer.experience && (
            <p className="text-xs text-gray-500">{trainer.experience}</p>
          )}
        </div>
      ))}
    </div>
  );
}





